import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'

class Fallback extends Component {
  render() {
    return (
      <div ref="fallback" style={{ height: '100vh' }}>
        <Grid
          style={{ height: '100%' }}
          container
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default Fallback
